import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './ErrorFallback.tsx';
import AppLoading from './AppLoading';
import { store } from './store.ts';
import { Provider } from 'react-redux';
import './i18n';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Provider store={store}>
                <Suspense fallback="">
                    <AppLoading />
                </Suspense>
            </Provider>
        </ErrorBoundary>
    </StrictMode>,
);
